import { QuestionType } from '../services/contentService';

function questionTypeOf(q: unknown): number | undefined {
  const raw = (q as { questionType?: number } | null | undefined)?.questionType;
  return typeof raw === 'number' ? raw : undefined;
}

/** True when the learner has entered any non-whitespace answer for the question. */
export function isQuizAnsweredForProgress(q: unknown, answer: string | undefined): boolean {
  if (answer == null) return false;
  const text = String(answer);
  const qt = questionTypeOf(q);

  if (qt === QuestionType.Crossword) {
    // Playable empties are '.' / ' '; '#' is block — count only real letters.
    for (let i = 0; i < text.length; i++) {
      const ch = text[i]!;
      if (ch !== '#' && ch !== '.' && ch !== ' ' && ch.trim() !== '') return true;
    }
    return false;
  }

  if (qt === QuestionType.FindTheWords) {
    return text
      .split(',')
      .map((t) => t.trim())
      .some((t) => t.length > 0);
  }

  return text.trim().length > 0;
}
